<div class="survey-progress-widget">
  @if (widgetTitle) {
    <div class="widget-title-header">
      <h4 class="widget-title">{{ titleMeta.isCustom ? widgetTitle : (widgetTitle | translate) }}{{ titleMeta.tailPrefix }}{{ titleMeta.tailKey | translate }}{{ titleMeta.tail }}</h4>
      <app-widget-org-filter
        [orgLevelId]="orgLevelOverrideId"
        (orgLevelIdChange)="onOrgLevelOverrideChange($event)">
      </app-widget-org-filter>
    </div>
  }
  @if (widgetTitle) {
    <hr class="widget-divider">
  }

  <div class="widget-content">
    @if (isLoading) {
      <div class="loading-container">
        <div class="loading-spinner"></div>
      </div>
    }

    @if (error && !isLoading) {
      <div class="error-container">
        <span class="error-icon">⚠</span>
        <span>{{ error | translate }}</span>
      </div>
    }

    @if (!isLoading && !error && surveys.length === 0) {
      <div class="empty-container">
        <span>{{ 'No active surveys' | translate }}</span>
      </div>
    }

    @if (!isLoading && !error && surveys.length > 0) {
      <div class="survey-list">
        @for (survey of surveys; track trackById($index, survey)) {
          <div class="survey-item" (click)="navigateToSurvey(survey.id)">
            <div class="survey-header">
              <span class="survey-name" [title]="survey.name">{{ survey.name }}</span>
              <span class="survey-badge" [ngClass]="survey.statusClass">
                {{ survey.statusLabel | translate }}
              </span>
              <span class="survey-count">{{ survey.completedSamples }}/{{ survey.totalSamples }}</span>
            </div>
            <div class="progress-row">
              <div class="progress-bar-container">
                <div class="progress-bar-fill" [style.width.%]="survey.progressPercentage"></div>
              </div>
              <span class="progress-percentage">{{ survey.progressPercentage }}%</span>
            </div>
            <div class="survey-meta">
              <span class="meta-item">
                <span class="meta-label">{{ 'Start' | translate }}:</span> {{ survey.formattedStartDate }}
              </span>
              <span class="meta-item">
                <span class="meta-label">{{ 'End' | translate }}:</span> {{ survey.formattedEndDate }}
              </span>
              @if (survey.daysRemaining !== null) {
                <span class="meta-item">
                  <span class="meta-label">{{ 'Remaining' | translate }}:</span> {{ survey.daysRemaining }}d
                </span>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (!isLoading && !error) {
      <div class="view-all-container">
        <button type="button" class="view-all-link" (click)="navigateToSurveys()">{{ 'View All' | translate }}</button>
      </div>
    }
  </div>
</div>